import React from "react"
import { motion } from 'framer-motion'


const Dashboard = () => {
    return (
        <motion.div className="relative flex flex-col w-full h-full">
            <motion.div className="grid grid-cols-1 gap-1 sm:grid-cols-1 md:grid-cols-4 xl:grid-cols-4 lg:grid-cols-4">
                {/* Total Sales */}
                <motion.div className="flex flex-col justify-center h-32 ring-1 ring-[lightGrey] drop-shadow-md px-5 py-2">
                    <motion.div className="text-black font-bold my-2">
                        Total Sales
                    </motion.div>
                    <motion.div className="flex flex-row my-2 justify-between">
                        $0.00
                    </motion.div>
                </motion.div>
                {/* Total Orders */}
                <motion.div className="flex flex-col justify-center h-32 ring-1 ring-[lightGrey] drop-shadow-md px-5 py-2">
                    <motion.div className="text-black font-bold my-2">
                        Total Orders
                    </motion.div>
                    <motion.div className="flex flex-row my-2 justify-between">
                        12
                    </motion.div>
                </motion.div>
                {/* Products Sold */}
                <motion.div className="flex flex-col justify-center h-32 ring-1 ring-[lightGrey] drop-shadow-md px-5 py-2">
                    <motion.div className="text-black font-bold my-2">
                        Product Sold
                    </motion.div>
                    <motion.div className="flex flex-row my-2 justify-between">
                        $0.00
                    </motion.div>
                </motion.div>
                {/* Total Products */}
                <motion.div className="flex flex-col justify-center h-32 ring-1 ring-[lightGrey] drop-shadow-md px-5 py-2">
                    <motion.div className="text-black font-bold my-2">
                        Total Products
                    </motion.div>
                    <motion.div className="flex flex-row my-2 justify-between">
                        $0.00
                    </motion.div>
                </motion.div>
                {/* Total Returns */}
                <motion.div className="flex flex-col justify-center h-32 ring-1 ring-[lightGrey] drop-shadow-md px-5 py-2">
                    <motion.div className="text-black font-bold my-2">
                        Total Returns
                    </motion.div>
                    <motion.div className="flex flex-row my-2 justify-between">
                        $0.00
                    </motion.div>
                </motion.div>
            </motion.div>
            {/* Charts */}
            <motion.div className="w-full relative px-2 my-2 flex flex-col">
                <motion.div className="text-xl font-bold">
                    {/* Charts */}
                </motion.div>
            </motion.div>
        </motion.div>
    )
}

export default Dashboard